export default __webpack_public_path__ + "static/4-de03f7661a480e8ea7a6b68b4e76bc89.jpeg";